import { IComplaintSummary } from "./complaintSummary.types"

export class ComplaintSummary implements IComplaintSummary {
  constructor(
    public open: number,
    public ombudsman: number,
    public cab: number,
    public ehu: number,
    public exec: number,
    public newerThan5Weeks: number,
    public olderThan5Weeks: number,
  ) {}
}
